import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Signbutton, { DebtbuttonActive } from "../forms/button";
import { Input } from "../forms/input";
import { Debtbutton } from "../forms/button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import { resetPassword } from "../../store/actions/profile";
import { getMailBackRequestStatus } from "../../store/actions/mailback";
import { REQ_BY } from "../../store/types";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import Paper from "@material-ui/core/Paper";
import { userLogout } from "../../store/actions";
import Image from "../Image";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6" style={{ marginRight: 60 }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export class SucesssPopUp extends Component {
  render() {
    return (
      <Dialog
        onClose={this.props.closeSucessModal}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
        fullWidth={true}
        // style={{ height: "95%" }}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={this.props.closeSucessModal}
        />

        <DialogContent>
          <div>
            <div className="modal-content-div">
              <Image
                src={"/images/tick.svg"}
                style={{ width: 100, height: 100 }}
                alt="tick"
              />
            </div>
            <div className="modal-succes-msg">Successfully raised a query</div>
            {!!this.props.response ? (
              <div
                style={{
                  fontSize: 15,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.response}
              </div>
            ) : (
              ""
            )}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Signbutton
              buttontitle="continue"
              onClick={this.props.closeSucessModal}
              width={100}
              // padding="10px 30px"
            />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export class PasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      showPassword: false,
      showOldPassword: false,
      confirmShowPassword: false,
      newPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      confirmPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      openSuccessPasword: false,
    };
  }

  componentDidMount() {
    this.setState({
      oldPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      showPassword: false,
      showOldPassword: false,
      confirmShowPassword: false,
      newPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      confirmPassword: {
        value: "",
        isShowError: false,
        isShowPasswordError: false,
      },
      openSuccessPasword: false,
    });
  }

  onBlurInput = (eve, label) => {
    var strongRegex = new RegExp(
      "^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
    );
    if (strongRegex.test(eve.target.value) === false) {
      if (label === "oldPassword") {
        this.setState({
          [label]: { ...this.state.oldPassword, isShowPasswordError: true },
        });
      } else if (label === "newPassword") {
        this.setState({
          [label]: { ...this.state.newPassword, isShowPasswordError: true },
        });
      } else if (label === "confirmPassword") {
        this.setState({
          [label]: { ...this.state.confirmPassword, isShowPasswordError: true },
        });
      }
    }
  };

  onChangeInput = (label) => (event) => {
    this.setState({
      [label]: { value: event.target.value },
    });
  };

  submit = async () => {
    if (
      !this.state.oldPassword.value ||
      !this.state.newPassword.value ||
      !this.state.confirmPassword.value
    ) {
      if (!this.state.oldPassword.value) {
        this.setState({
          oldPassword: {
            ...this.state.oldPassword,
            isShowError: true,
            errorMessage: "(old Password is mandatory)",
          },
        });
      }
      if (!this.state.newPassword.value) {
        this.setState({
          newPassword: {
            ...this.state.newPassword,
            isShowError: true,
            errorMessage: "(new Password is mandatory)",
          },
        });
      }
      if (!this.state.confirmPassword.value) {
        this.setState({
          confirmPassword: {
            ...this.state.confirmPassword,
            isShowError: true,
            errorMessage: "(confirm Password is mandatory)",
          },
        });
      }
    } else if (this.state.oldPassword.value === this.state.newPassword.value) {
      this.setState({
        newPassword: {
          ...this.state.newPassword,
          isShowError: true,
          errorMessage: "(*Old password and New Password should not be Same)",
        },
      });
    } else if (
      this.state.newPassword.value !== this.state.confirmPassword.value
    ) {
      this.setState({
        confirmPassword: {
          ...this.state.confirmPassword,
          isShowError: true,
          errorMessage: "(Password does not match)",
        },
      });
    } else {
      const response = await this.props.resetPassword({
        newPassword: this.state.newPassword.value,
        oldpassword: this.state.oldPassword.value,
        ReqBy: REQ_BY,
        userid: this.props.userid,
      });
      if (response) {
        this.props.closeModal();
        // this.props.history.replace( "/Login");
        this.setState({
          openSuccessPasword: true,
        });
      }
    }
  };
  closePasswordModal = () => {
    this.props.userLogout();
    this.props.history.replace("/Login");
    this.setState({
      openSuccessPasword: false,
    });
  };

  closeModalPopUp = () => {
    this.props.closeModal();
    this.setState({
      oldPassword: { value: "" },
      newPassword: { value: "" },
      confirmPassword: { value: "" },
    });
  };

  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.props.openPasswordModal}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.closeModalPopUp}
          >
            <div
              style={{
                marginLeft: "15%",
              }}
            >
              Change Password
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="change-password-margin">
              <div className="input-margin">
                <Input
                  name="Old Password"
                  value={this.state.oldPassword.value}
                  type={!!this.state.showOldPassword ? "text" : "password"}
                  onChange={this.onChangeInput("oldPassword")}
                  onBlur={(value) => this.onBlurInput(value, "oldPassword")}
                  height={18}
                  image2={
                    !!this.state.showOldPassword &&
                    !this.state.showOldPassword.value
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  height={
                    !!this.state.showOldPassword &&
                    !this.state.showOldPassword.value
                      ? 10
                      : 15
                  }
                  onClick={() => {
                    this.setState({
                      showOldPassword: !this.state.showOldPassword,
                    });
                  }}
                  isShowError={this.state.oldPassword.isShowError}
                  errorMessage={this.state.oldPassword.errorMessage}
                />
              </div>
              <div className="input-margin">
                <Input
                  type={!!this.state.showPassword ? "text" : "password"}
                  name="New Password"
                  image2={
                    !!this.state.showPassword && !this.state.showPassword.value
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  height={
                    !!this.state.showPassword && !this.state.showPassword.value
                      ? 10
                      : 15
                  }
                  value={this.state.newPassword.value}
                  onChange={this.onChangeInput("newPassword")}
                  onBlur={(value) => this.onBlurInput(value, "newPassword")}
                  onClick={() => {
                    this.setState({
                      showPassword: !this.state.showPassword,
                    });
                  }}
                  isShowError={this.state.newPassword.isShowError}
                  isShowPasswordError={
                    this.state.newPassword.isShowPasswordError
                  }
                  errorMessage={this.state.newPassword.errorMessage}
                />
              </div>
              <div className="input-margin">
                <Input
                  name="Confirm Password"
                  type={!!this.state.confirmShowPassword ? "text" : "password"}
                  image2={
                    !!this.state.confirmShowPassword &&
                    !this.state.confirmShowPassword.value
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  height={
                    !!this.state.confirmShowPassword &&
                    !this.state.confirmShowPassword.value
                      ? 10
                      : 15
                  }
                  onClick={() => {
                    this.setState({
                      confirmShowPassword: !this.state.confirmShowPassword,
                    });
                  }}
                  value={this.state.confirmPassword.value}
                  onChange={this.onChangeInput("confirmPassword")}
                  onBlur={(eve) => this.onBlurInput(eve, "confirmPassword")}
                  isShowError={this.state.confirmPassword.isShowError}
                  isShowPasswordError={
                    this.state.confirmPassword.isShowPasswordError
                  }
                  errorMessage={this.state.confirmPassword.errorMessage}
                />
              </div>
              <div className="flex-sp-bt" style={{ margin: "30px 0px" }}>
                <DebtbuttonActive
                  buttontitle="SUBMIT"
                  onClick={() => this.submit()}
                />
                <Debtbutton
                  buttontitle="CANCEL"
                  onClick={this.closeModalPopUp}
                  isShowError={this.state.isShowError}
                />
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <CustomizedDialogs
          open={this.state.openSuccessPasword}
          closeModal={() => this.closePasswordModal()}
          passwordSucess={this.state.openSuccessPasword === true ? true : false}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ authReducer }) => {
  return {
    userid: authReducer.userId,
  };
};

export const PasswordDialog = connect(mapStateToProps, {
  resetPassword,
  userLogout,
})(PasswordModal);

export class NonLoginServicesDialog extends Component {
  render() {
    return (
      <Dialog
        onClose={this.props.closeModal}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
        fullWidth={true}
        fullScreen={true}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={this.props.closeModal}
        >
          Distributor Non-Login Services
        </DialogTitle>
        <DialogContent>
          <div>
            <div>
              <div
                style={{
                  backgroundColor: "#e5f2f9",
                  color: "#003d7b",
                  padding: "7px 10px",
                  fontSize: 14,
                  borderRadius: 3,
                  margin: "10px 0px",
                }}
              >
                Services
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <NonLoginServices
                  name="PAN Based Services"
                  src={"/images/nl_icon_s.svg"}
                  link="https://mfs.kfintech.com/mfs/GeneralPages/ItPAN.aspx"
                />
                <NonLoginServices
                  name="Know Your investor Transaction Status"
                  src={"/images/nl_icon_s.svg"}
                  link="https://mfs.kfintech.com/mfs/InvestorServices/General/InvTransactionStatusnew.aspx"
                />
                <NonLoginServices
                  name="FinNet Login"
                  src={"/images/nl_icon_s.svg"}
                  link="https://finnet.karvymfs.com/FinNet/(S(zbe1sw45sydsn255sfmnkzu5))/FinNetLogin.aspx"
                />
                <NonLoginServices
                  name="Historical Nav"
                  src={"/images/nl_icon_s.svg"}
                  link="https://mfs.kfintech.com/mfs/NAVDividend/NAV_Dividend.aspx"
                />
              </div>
            </div>

            <div>
              <div
                style={{
                  backgroundColor: "#e5f2f9",
                  color: "#003d7b",
                  padding: "7px 10px",
                  fontSize: 14,
                  borderRadius: 3,
                  margin: "10px 0px",
                }}
              >
                Forms
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <NonLoginServices
                  name="Common Transaction Form"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/Distributor/COMMONTRANSACTIONFORM.pdf"
                />
                <NonLoginServices
                  name="CKYC Application Form"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/Downloads/CKYCApplicationForm.pdf"
                />
              </div>
            </div>

            <div>
              <div
                style={{
                  backgroundColor: "#e5f2f9",
                  color: "#003d7b",
                  padding: "7px 10px",
                  fontSize: 14,
                  borderRadius: 3,
                  margin: "10px 0px",
                }}
              >
                Downloads
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <NonLoginServices
                  name="Distributor manual"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/Distributor/Downloads/DistributorManual.pdf"
                />
                <NonLoginServices
                  name="Merger of Schemes in Edelweiss MF"
                  src={"/images/nl_icon_f.svg"}
                  link="https://www.karvymfs.com/karvy/distributor/distributor_Login.aspx"
                />
                <NonLoginServices
                  name="NACH Form mandates"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/NACH.aspx"
                />
                <NonLoginServices
                  name="
                  SEBI Circular-unclaimed amounts in liquid funds"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/SEBICircularDistributor.aspx"
                />
                <NonLoginServices
                  name="SIP/STP/SWP Cancellation Request"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/Distributor/RequestForCancellationOfSIP-STP-SWP.pdf"
                />
                <NonLoginServices
                  name="KFintech Easy SMS services guide"
                  src={"/images/nl_icon_f.svg"}
                  link="https://mfs.kfintech.com/mfs/KFintechEasySMSservicesguide.pdf"
                />
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export class MailBacKRequestStatusPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      record: false,
    };
  }

  onDateChange = (event) => {
    this.setState({
      date: event,
    });
  };

  submit = async () => {
    const { date } = this.state;
    let startDateValue;
    if (date) {
      startDateValue = date.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "numeric",
      });
    }
    const params = {
      FromDate: startDateValue,
    };
    const response = await this.props.getMailBackRequestStatus(params);
    if (!response) {
      this.setState({
        record: true,
      });
    }
  };

  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.close}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}

          // fullWidth={true}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.props.close}>
            MailBack Request Status
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: 20,
                fontFamily: "Rubik-Bold",
                margin: "30px 10%",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  InputProps={{ readOnly: true }}
                  required={true}
                  className="selects"
                  onChange={(e) => this.onDateChange(e)}
                  disableFuture={true}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  id="mui-pickers-date"
                  value={this.state.date}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Signbutton
                buttontitle="continue"
                onClick={this.submit}
                width={100}
                // padding="10px 30px"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export const MBRStatusDialog = connect(null, { getMailBackRequestStatus })(
  MailBacKRequestStatusPopUp
);

export class NonLoginServices extends Component {
  render() {
    return (
      <Paper className="non-login-pop-up-paper">
        <Image src={this.props.src} style={{ height: 30, width: 30 }} />
        <a
          className="pop-up-title"
          href={this.props.link}
          target="_blank"
          style={{
            color: "black",
            textDecoration: "none",
            fontSize: 14,
          }}
        >
          {this.props.name}
        </a>
      </Paper>
    );
  }
}

export class KycNotDoneDialog extends React.Component {
  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.close}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.close}
          />
          <DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: 20,
                margin: "30px 10%",
              }}
            >
             
             {!!this.props.message
                ? this.props.message
                : "This Client is not KYC compliant.Do you want to complete the KYC process?"}

            </div>
          </DialogContent>
          <div
            className="modal-continue-button "
            style={{
              margin: "20px 0px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Signbutton
                buttontitle="Okay"
                onClick={this.props.continue}
                width={200}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default class CustomizedDialogs extends React.Component {
  render() {
    return (
      <div>
        <Dialog
          onClose={this.props.closeModal}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          fullWidth={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.props.closeModal}
          />
          <DialogContent>
            <div className="modal-content-div">
              <Image
                src={"/images/tick.svg"}
                className="custom-dialog-image"
                alt="tick"
              />
            </div>
            {this.props.cas === true ||
            this.props.Gas === true ||
            this.props.componentName === "MailBackSoa" ||
            this.props.passwordSucess ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "25px",
                  color: "green",
                }}
              >
                {!!this.props.passwordSucess
                  ? this.props.message || "Password Changed Successfully"
                  : !!this.props.Gas
                  ? this.props.error
                  : "success"}
                <div
                  style={{
                    color: "black",
                    fontSize: 13,
                    marginTop: 10,
                    padding: "10px 0px",
                    backgroundColor: !!this.props.cas ? "aliceblue" : "",
                  }}
                >
                  {this.props.cas === true
                    ? "A mail will be sent to above entered Email Id within 30 minutes."
                    : ""}
                  {this.props.Gas === true && this.props.error === "Success"
                    ? "A mail will be sent to your registered email"
                    : ""}
                </div>
              </div>
            ) : (this.props.componentName === "MailBacKRequest" &&
                this.props.refNo) ||
              (this.props.componentName === "SWP" && this.props.refNo) ||
              (this.props.componentName === "REDEMPTION" &&
                this.props.refNo) ? (
              <div>
                {!!this.props.componentName &&
                (this.props.componentName === "REDEMPTION" ||
                  this.props.componentName === "SWP") ? (
                  <div className="modal-succes-msg">
                    Successfully Initiated Transaction
                  </div>
                ) : (
                  ""
                )}
                <div className="modal-text-container">
                  <div>
                    {!!this.props.componentName &&
                    (this.props.componentName === "REDEMPTION" ||
                      this.props.componentName === "SWP") ? (
                      <div className="modal-text">
                        Transaction for{" "}
                        <strong>{this.props.componentName}</strong> has been
                        initiated Successfully.
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: 15,
                        padding: "15px 5px",
                      }}
                    >
                      Your request is successfully registered with reference no
                      -
                      <span
                        style={{
                          fontSize: 18,
                        }}
                      >
                        {this.props.refNo}
                      </span>
                      .{" "}
                      {this.props.myself === true ? "distributor" : "investor"}{" "}
                      will receive a mail to approval
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="modal-succes-msg">
                  {this.props.componentName === "Sip cancellation" ||
                  this.props.componentName === "SWP cancellation" ||
                  this.props.componentName === "STP cancellation"
                    ? `${
                        this.props.componentName.slice(0, 4).toUpperCase() +
                        this.props.componentName.slice(4, 16)
                      } request has been initiated`
                    : this.props.componentName === "Sip Pause"
                    ? ` SIP Pause has been initiated Successfully`
                    : `Successfully Initiated Transaction`}
                </div>

                {this.props.type === "STP" || this.props.type === "SWITCH" ? (
                  <div className="modal-text-container">
                    <div className="modal-text">
                      Transaction for <strong>{this.props.type}</strong> has
                      been initiated successfully.
                    </div>
                    <div className="modal-text">
                      You have initiated the transaction successfully with
                      reference number:
                      <strong style={{ padding: "0px 5px" }}>
                        {this.props.refNo}
                      </strong>
                      investor will receive an mail for approval.
                    </div>
                  </div>
                ) : (
                  <div className="modal-text-container">
                    {!!this.props.reqtype ? (
                      <div className="modal-text">
                        Transaction for <strong>{this.props.reqtype}</strong>
                        {!!this.props.Nctihno &&
                          ` with the IHNO : ${this.props.Nctihno} `}
                        has been initiated successfully
                      </div>
                    ) : (
                      this.props.componentName !== "Sip cancellation" ||
                      this.props.componentName !== "SWP cancellation" ||
                      this.props.componentName !== "STP cancellation" ||
                      (this.props.componentName !== "Sip Pause" && (
                        <div className="modal-text">
                          Transaction for{" "}
                          <strong>
                            {!!this.props.refrence
                              ? this.props.refrence.new_type
                              : ""}
                            {!!this.props.refNo ? "SIP" : ""}
                          </strong>{" "}
                          has been initiated successfully.
                        </div>
                      ))
                    )}
                    {!!this.props.reqtype ? (
                      <div className="modal-text">
                        Your investor will receive the details via an mail and
                        sms
                      </div>
                    ) : this.props.componentName === "Sip cancellation" ||
                      this.props.componentName === "SWP cancellation" ||
                      this.props.componentName === "STP cancellation" ? (
                      <div className="modal-text">
                        Transaction for{" "}
                        <strong>
                          {this.props.componentName.slice(0, 4).toUpperCase() +
                            this.props.componentName.charAt(4).toUpperCase() +
                            this.props.componentName.slice(5, 16)}
                        </strong>{" "}
                        with the IH No.{" "}
                        <strong>{this.props.refNo.value}</strong> is pending for
                        investor confirmation.
                      </div>
                    ) : this.props.componentName === "Sip Pause" ? (
                      this.props.refNo.errorMessage
                    ) : this.props.transactName === "NFO" ? (
                      <>
                        <div
                          className="modal-text"
                          style={{ fontFamily: "Rubik-Bold" }}
                        >
                          Transaction for NFO has been initiated Successfully.
                        </div>
                        <div className="modal-text">
                          Link for <strong>{this.props.scheme}</strong> scheme
                          is generated
                        </div>
                      </>
                    ) : (
                      <div>
                        <div className="modal-text">
                          Transaction for{" "}
                          <strong>{this.props.transactName}</strong> has been
                          initiated successfully.
                        </div>
                        <div className="modal-text">
                          Your investor will receive the details via an email
                          and sms with reference number
                          <strong style={{ margin: "0px 10px" }}>
                            {!!this.props.refrence
                              ? this.props.refrence.value
                              : ""}
                            {!!this.props.refNo ? this.props.refNo : ""}
                          </strong>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            <div className="modal-continue-button">
              {this.props.cas === true && !this.props.componentName ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {/* <div className="dual-margin"> */}
                  <Signbutton
                    buttontitle="Continue"
                    onClick={this.props.closeYesModal}
                    width={100}
                    // padding="10px 30px"
                  />
                  {/* </div> */}
                  {/* <div className="dual-margin">
                    <Signbutton
                      buttontitle="no"
                      onClick={this.props.closeNoModal}
                      width={100}
                      // padding="10px 30px"
                    />
                  </div> */}
                </div>
              ) : (
                <Signbutton
                  buttontitle={
                    this.props.componentName === "MailBackSoa"
                      ? "Ok"
                      : "Continue"
                  }
                  onClick={this.props.closeModal}
                />
              )}
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export class SipCancelModal extends Component {
  render() {
    return (
      <Dialog
        onClose={this.props.closeModal}
        aria-labelledby="customized-dialog-title"
        open={this.props.open || this.props.rejectionreasonsOpen}
        fullWidth={true}
        style={{ height: "95%" }}
      >
        {!this.props.rejectionreasonsOpen && (
          <>
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.props.closeModal}
            >
              SIP Cancellation
            </DialogTitle>

            <DialogContent>
              <div
                style={{
                  fontSize: 15,
                  fontFamily: "OpenSans-SemiBold",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {this.props.message}
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="dual-margin" style={{ margin: "0px 15px" }}>
                  <Signbutton
                    buttontitle="Yes"
                    onClick={this.props.closeYesModal}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
                <div className="dual-margin" style={{ margin: "0px 15px" }}>
                  <Signbutton
                    buttontitle="No"
                    onClick={this.props.closeNoModal}
                    width={100}
                    padding="10px 30px"
                  />
                </div>
              </div>
            </DialogContent>
          </>
        )}
        {this.props.rejectionreasonsOpen && (
          <>
            <div>
              <RejectionReason {...this.props} />
            </div>
            <div
              style={{ display: "flex", justifyContent: "center", padding: 7 }}
            >
              <div className="dual-margin" style={{ margin: "0px 15px" }}>
                <Signbutton
                  buttontitle="back"
                  onClick={this.props.closeNoModal}
                  width={100}
                  padding="10px 30px"
                  margin={5}
                />
              </div>
              <div className="dual-margin" style={{ margin: "0px 15px" }}>
                <Signbutton
                  buttontitle="proceed"
                  onClick={this.props.closemodelafterrejecttion}
                  width={100}
                  padding="10px 30px"
                  margin={5}
                />
              </div>
            </div>
          </>
        )}
      </Dialog>
    );
  }
}

export class EnachModal extends Component {
  render() {
    return (
      <Dialog
        onClose={this.props.closeModal}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
        fullWidth={true}
      >
        <DialogContent>
          <div className="modal-content-div">
            <Image
              src={"/images/tick.svg"}
              style={{ width: 100, height: 100 }}
              alt="tick"
            />
          </div>
          <div
            style={{
              fontSize: 15,
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {this.props.message}
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="dual-margin">
              <Signbutton
                buttontitle="OK"
                onClick={this.props.closeYesModal}
                width={100}
                // padding="10px 30px"
              />
            </div>
            {/* <div className="dual-margin">
              <Signbutton
                buttontitle="No"
                onClick={this.props.closeNoModal}
                width={100}
                padding="10px 30px"
              />
            </div> */}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export class PosterDialog extends Component {
  render() {
    return (
      <Dialog
        onClose={this.props.close}
        aria-labelledby="customized-dialog-title"
        open={this.props.open}
        fullWidth={true}
        className="posterDialog"
      >
        <DialogContent style={{ padding: "0px" }}>
          <div
            style={{
              fontSize: 16,
              color: "#194b7e",
            }}
            className="total-div"
          >
            <div
              style={{
                position: "absolute",
                zIndex: 99999999999,
                right: 2,
                top: 2,
              }}
              onClick={this.props.close}
            >
              <Image
                src={"/images/cross.png"}
                style={{ height: 30, width: 30 }}
              />
            </div>
            <Image src={"/images/NFO_popup.png"} className="big-image" />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export const RejectionReason = (props) => {
  return (
    <div style={{ padding: 20, paddingBottom: 0 }}>
      <h2>Cancellation Reasons</h2>
      {props.rejectionReasons.map((reason) => (
        <div
          key={reason.RejReason}
          style={{ display: "flex", alignItems: "center", padding: 7 }}
        >
          <input
            type="radio"
            name="rejectionReason"
            value={reason.RejReason}
            checked={props.selectedReason === reason.RejReason}
            onChange={props.handleReasonChange}
            className="square-radio"
          />
          <label style={{ margin: 0 }}>{reason.RejReason}</label>
        </div>
      ))}
      {!!props.reasonMandatory && (
        <span style={{ color: "red" }}>*Rejection reason is mandatory</span>
      )}

      <p>Selected Reason: {props.selectedReason}</p>
      {props.selectedReason.includes("Others") && (
        <div style={{ marginBottom: 20 }}>
          <Input
            bordercolor="#a6a6a6"
            placeholder="Enter the Reason"
            value={props.othersText.value}
            isShowError={props.othersText.isError}
            errorMessage={props.othersText.errorMessage}
            onChange={props.selectedotherreason}
          />
        </div>
      )}
    </div>
  );
};

export class DashboardPosterDialog extends Component {
  render() {
    return (
      <>
        <div className="Banner">
          <Dialog
            onClose={this.props.close}
            aria-labelledby="customized-dialog-title"
            open={this.props.open}
            className="posterDialog"
            // fullWidth={true}
          >
            <DialogContent
              style={{
                width: "100%",
                height: "65%",
                padding: 0,
              }}
            >
              <div>
                <h3
                  style={{ padding: 10, paddingBottom: 0, textAlign: "center" }}
                >
                  Important Regulatory Update on KYC Status
                </h3>
                <div class="custom-div">
                  As per the Master Circular issued by SEBI on KYC requirements,
                  Investors with ‘KYC Registered’ status are requested to do
                  their KYC again to become ‘KYC Validated’ by visiting{" "}
                  <a
                    href="https://mfs.kfintech.com/Investor/General/ValidateKYC/"
                    target="_blank"
                  >
                    https://mfs.kfintech.com/Investor/General/ValidateKYC/
                  </a>{" "}
                  <br></br>
                  <a
                    href="https://www.sebi.gov.in/legal/master-circulars/oct-2023/master-circular-on-know-your-client-kyc-norms-for-the-securities-market_77945.html"
                    target="_blank"
                  >
                    Click here
                  </a>{" "}
                  to know more about the circular.
                </div>
              </div>
              <div
                style={{
                  position: "absolute",
                  zIndex: 999,
                  right: 5,
                  top: 5,
                  cursor: "pointer",
                }}
                onClick={this.props.close}
              >
                <Image
                  src={"/images/cross.png"}
                  style={{
                    height: 20,
                    width: 20,
                    cursor: "pointer",
                  }}
                />
              </div>
            </DialogContent>
          </Dialog>
        </div>
        <div className="Responsive-Banner">
          <Dialog
            onClose={this.props.close}
            aria-labelledby="customized-dialog-title"
            open={this.props.open}
            className="posterDialog-Responsive"
            // fullWidth={true}
          >
            <DialogContent
              style={{
                width: "100%",
                height: "65%",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <Image
                src={"/images/newmobilebanner.png"}
                style={{ width: "100%", height: "70%" }}
                onClick={() => window.open("https://bit.ly/4aNSr7h")}
              />
              <div
                style={{
                  position: "absolute",
                  zIndex: 999,
                  right: 5,
                  top: 5,
                  cursor: "pointer",
                }}
                onClick={this.props.close}
              >
                <Image
                  src={"/images/cross.png"}
                  style={{
                    height: 20,
                    width: 20,
                    cursor: "pointer",
                  }}
                />
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  }
}
